// @flow
import styled from 'styled-components';
import { TwoColumnLayoutWithSidebarWidgets } from "../../components";
import { below } from "../../assets/css/media";

export const DraftLayout = styled(TwoColumnLayoutWithSidebarWidgets)`
	${below.desktop`
		padding: 0;

		& > :first-child {
			width: 100%;
		}
	`};

	 ${below.tablet`
		.player-stats {
			display: none;
		}
	`};
`;

export default DraftLayout;


// WEBPACK FOOTER //
// ./src/components/Draft/DraftLayout.js